import { IPromotionState } from '../types';

export const selectService = (services: IPromotionState['services']): IPromotionState['services'] => {
  const selectedService = services.find(service => service.selected);

  if (selectedService) {
    return services;
  }

  const recommendedService = services.find(service => service.isRecommended);

  if (recommendedService) {
    return services.map(service => ({
      ...service,
      selected: service.type === recommendedService.type,
    }));
  }

  const firstNotDisabledService = services.find(service => !service.disabled);

  if (firstNotDisabledService) {
    return services.map(service => ({
      ...service,
      selected: service.type === firstNotDisabledService.type,
    }));
  }

  return services;
};
